import { resolve } from "inversify-react";
import * as React from "react";
import Select from "../../../core/ui/select";
import HttpService from "../../../services/http.service";

export interface EditionTypeSelectProps {
    mode?: "display" | "edit";
    label?: string;
    value?: any;
    type?: "light" | "dark" | "fill" | "grey";
    placeholder?: string;
    extraData?: Array<{}>;
    disabled?: boolean;

    editionData?: {
      editionNumber: number;
      editionCount: number;
    };
    onChange?: (data: any) => void;
}

export interface EditionTypeSelectState {
}

export default class EditionTypeSelect extends React.Component<EditionTypeSelectProps, EditionTypeSelectState> {
    @resolve(HttpService)
    public httpService: HttpService;

    constructor(props: any) {
    super(props);

    this.state = {
    };
  }

    public optionsRequest =  () => {
    return new Promise<any>((resolve, reject) => {

      // this.httpService.get<any[]>('rarities/').then(result => {
      //     var extra = this.props.extraData || [];
      //     resolve([...extra,...result])
      // });
      resolve([
          {id: "limited-edition", display_name: "Limited edition"},
          {id: "hors-du-commerce", display_name: "Hors du Commerce"},
          {id: "artist-proof", display_name: "Artist Proof"},
      ]);
    });
  }

    public render() {

    if (!this.httpService) {
        return null;
    }

    return (<Select
        label={this.props.label}
        keyProperty="id"
        showArrow={true}
        style={this.props.type}
        mode={this.props.mode || "edit"}
        value={this.props.value}
        placeholder={this.props.placeholder}
        textProperty="display_name"
        disabled={this.props.disabled}
        labelCB={this.props.editionData ? (x) => {
          const data = this.props.editionData as any;

          return `${x} (${data.editionNumber} - ${data.editionCount})`;
        } : undefined}
        onChange={this.props.onChange}
        request={this.optionsRequest}
        formatter={(e) => e}
      />)
    ;
  }
}



// WEBPACK FOOTER //
// ./src/core/ui/data-component/edition-type-select.tsx